import { Controller } from "@hotwired/stimulus"

// Makes a whole table row (or any element) navigate like a link, through Turbo
// so the list's scroll position is preserved on return (see scroll_memory).
// Clicks on interactive children (links, buttons, form fields) or anything
// marked [data-row-link-ignore] are left alone, so per-cell stopPropagation
// hacks aren't needed. Cmd/Ctrl/middle-click opens in a new tab, like a real
// link would.
export default class extends Controller {
  static values = { url: String }

  navigate(event) {
    if (event.button !== 0 && event.button !== 1) return
    if (event.target.closest("a, button, input, select, textarea, label, [data-row-link-ignore]")) return

    if (event.metaKey || event.ctrlKey || event.button === 1) {
      window.open(this.urlValue, "_blank")
      return
    }

    event.preventDefault()
    window.Turbo.visit(this.urlValue)
  }
}
